import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    const id = document.getElementById('contentWrapper');
    if (id) {
      id.scrollTop = 0;
    }
  }, [location.pathname]);

  return null;
}

export default ScrollToTop;
